module.exports = __webpack_public_path__ + "static/media/rtf.7a2f32c4.png";